<template>
    <div class="col-md-12 m-t-20">
        <div class="card">
            <div class="card-header m-t-10">
                <div class="row">
                    <div class="d-md-flex align-items-center col-md-6">
                        <div>
                            <h4 class="m-b-0 card-title">Purchase Order Summary</h4>
                            <h5 class="card-subtitle">Comprehensive summary details of purchase</h5>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-6">
                                <v-md-date-range-picker
                                        :auto-apply="false"
                                        :opens="opens"
                                        :show-activator-bar="false"
                                        :show-activator-label="false"
                                        :show-custom-range-label="value"
                                        @change="change"
                                        show-year-select>
                                </v-md-date-range-picker>
                            </div>
                            <div class="col-md-2">
                                <button @click="getPoSummaryInRange(1)" class="btn btn-light btn-outline-success" style="height: 42px;" type="button">Go!</button>
                            </div>
                            <div class="col-md-2 btn-arrange">
                                <button @click="reset()" class="btn btn-light btn-outline-secondary" style="height: 42px;" type="button">Reset!</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row m-t-30">
                    <div class="col-lg-6 col-md-12 col-sm-12 m-b-30">
                        <div class="row">
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-cyan"></i>
                                <h3 class="m-b-0 font-medium">{{draftPoCount}}</h3>
                                <span>Draft</span>
                            </div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-info"></i>
                                <h3 class="m-b-0 font-medium">{{issuedPoCount}}</h3>
                                <span>Issued</span>
                            </div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-light-green"></i>
                                <h3 class="m-b-0 font-medium">{{receivedPoCount}}</h3>
                                <span>Received</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 col-sm-12 m-b-30">
                        <div class="row">
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-light-green"></i>
                                <h3 class="m-b-0 font-medium">{{partialReceivedPoCount}}</h3>
                                <span>Partially Received</span>
                            </div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-dark-green"></i>
                                <h3 class="m-b-0 font-medium">{{paidPoCount}}</h3>
                                <span>Paid</span>
                            </div>
                            <div class="col-4 border-right">
                                <i class="fa fa-circle text-inverse"></i>
                                <h3 class="m-b-0 font-medium">{{canceledPoCount}}</h3>
                                <span>Cancelled</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card card-body printableArea m-t-10" v-if="po.length > 0">
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive " style="clear: both;">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th class="text-left">Status</th>
                                    <th class="text-left">Number</th>
                                    <th class="text-left">Created On</th>
                                    <th class="text-left">Amount</th>
                                    <th class="text-left">Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(p, index) in po">
                                    <td class="text-left">
                                        <p v-if="p.status === 'DRAFT'"><span class="label label-cyan">Draft</span></p>
                                        <p v-if="p.status === 'ISSUED'"><span class="label label-info">Issued</span></p>
                                        <p v-if="p.status === 'CANCELLED'"><span class="label label-inverse">Cancelled</span></p>
                                        <p v-if="p.status === 'RECEIVED'"><span class="label label-light-green">Received</span></p>
                                        <p v-if="p.status === 'PARTIALLY_RECEIVED'"><span class="label label-light-green">Received Partial</span></p>
                                        <p v-if="p.status === 'PAID'"><span class="label label-dark-green">Paid</span></p>
                                    </td>
                                    <td class="text-left">{{p.id}}</td>
                                    <td class="text-left">{{p.created_at | date}}</td>
                                    <td class="text-left">{{p.total | money}}</td>
                                    <td class="text-left">
                                        <a @click="viewPo(p.id)" href="javascript:void(0)">
                                            <h6>View Details</h6>
                                        </a>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <span>Showing {{pageNumber}} of {{pageCount}}</span>
                    </div>
                    <div class="col-6">
                        <paginate
                                :click-handler="pageHandler"
                                :container-class="'pagination float-right'"
                                :margin-pages="2"
                                :next-class="'page-link'"
                                :next-text="'Next'"
                                :page-class="'page-link'"
                                :page-count=pageCount
                                :page-range="3"
                                :prev-class="'page-link'"
                                :prev-text="'Prev'"
                                v-model="pageNumber">
                        </paginate>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import Paginate from 'vuejs-paginate';

    export default {
        name: "Purchases",
        props: ["memberid", "events"],
        computed: {
            ...mapGetters(["currentOrg"])
        },
        components: {Paginate},
        data() {
            return {
                po: [],
                draftPoCount: 0,
                issuedPoCount: 0,
                receivedPoCount: 0,
                partialReceivedPoCount: 0,
                paidPoCount: 0,
                canceledPoCount: 0,
                pageCount: 1,
                pageNumber: 1,
                total: 0,
                po_from_date: null,
                po_to_date: null,
                opens: 'left',
                value: true
            }
        },
        mounted() {
            this.getPoSummary(1);
        },
        methods: {
            change(e) {
                this.po_from_date = e[0].toDate();
                this.po_to_date   = e[1].toDate();
            },
            async getPoSummary(page) {
                $(".preloader").fadeIn();
                let result = await this.$http
                .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/" + this.memberid + "/purchaseSummary", {
                    params: {
                        page: page,
                        perPage: 3
                    }
                });

                $(".preloader").fadeOut();
                this.total = result.data.total;
                this.po    = result.data.po;
                this.setPageCount();
                let allPo = result.data.allPo;

                let draftPo                 = await _.filter(allPo, {"status": "DRAFT"});
                let issuedPo                = await _.filter(allPo, {"status": "ISSUED"});
                let receivedPo              = await _.filter(allPo, {"status": "RECEIVED"});
                let partialReceivedPo       = await _.filter(allPo, {"status": "PARTIALLY_RECEIVED"});
                let paidPo                  = await _.filter(allPo, {"status": "PAID"});
                let canceledPo              = await _.filter(allPo, {"status": "CANCELLED"});
                this.draftPoCount           = draftPo.length;
                this.issuedPoCount          = issuedPo.length;
                this.receivedPoCount        = receivedPo.length;
                this.partialReceivedPoCount = partialReceivedPo.length;
                this.paidPoCount            = paidPo.length;
                this.canceledPoCount        = canceledPo.length;
            },
            async getPoSummaryInRange(page) {
                $(".preloader").fadeIn();
                let result = await this.$http
                .get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/" + this.memberid + "/purchaseSummary", {
                    params: {
                        page: page,
                        perPage: 3,
                        fromDate: this.po_from_date,
                        toDate: this.po_to_date
                    }
                });

                $(".preloader").fadeOut();
                this.total = result.data.total;
                this.po    = result.data.po;
                this.setPageCount();
                let allPo = result.data.allPo;

                let draftPo                 = await _.filter(allPo, {"status": "DRAFT"});
                let issuedPo                = await _.filter(allPo, {"status": "ISSUED"});
                let receivedPo              = await _.filter(allPo, {"status": "RECEIVED"});
                let partialReceivedPo       = await _.filter(allPo, {"status": "PARTIALLY_RECEIVED"});
                let paidPo                  = await _.filter(allPo, {"status": "PAID"});
                let canceledPo              = await _.filter(allPo, {"status": "CANCELLED"});
                this.draftPoCount           = draftPo.length;
                this.issuedPoCount          = issuedPo.length;
                this.receivedPoCount        = receivedPo.length;
                this.partialReceivedPoCount = partialReceivedPo.length;
                this.paidPoCount            = paidPo.length;
                this.canceledPoCount        = canceledPo.length;
            },
            pageHandler(pageNum) {
                this.pageNumber = pageNum;
                if(this.po_from_date === null || this.po_to_date === null) {
                    this.getPoSummary(pageNum);
                } else {
                    this.getPoSummaryInRange(pageNum)
                }

            },
            setPageCount() {
                this.pageCount = this.total <= 3 ? 1 : Math.ceil(this.total / 3);
            },
            reset() {
                this.po_from_date = null;
                this.po_to_date   = null;
                this.getPoSummary(1);
            },
            viewPo(poid) {
                this.$router.push({name: "viewpo", params: {poid: poid}});
            }
        }
    }
</script>

<style scoped>
    .btn-arrange {
        margin-left: -38px;
    }
</style>
